import { useState, createElement, useEffect } from 'react'
import ReactDom from 'react-dom'
import { Button, Modal, Form, Radio, Checkbox, CheckboxGroup, Bubble } from 'tea-component'
import './index.scss'
import { getLocale } from 'umi'
enum timeScaleOptions {
  _5MIN = '5',
  _10MIN = '10',
  _60MIN = '60',
}
const { _5MIN, _10MIN, _60MIN, } = timeScaleOptions
interface DownloadOptions {
  visible?: boolean
  options: {
    table: {
      firstName: string
      secondName: string
      default?: number
    }
    timeScale: {
      show: {
        [key in timeScaleOptions]: boolean
      }
      disabled: {
        [key in timeScaleOptions]: boolean
      }
      default: string
    }
    sort?: {
      default?: 0 | 1 //降序、升序
    }
  }
  onConfirm?: (formValue) => void
  onExited?: () => void
  formatMessage?: (val: any) => string
}
const DownloadOptionsModal = (props: DownloadOptions) => {
  const { onConfirm, onExited, options, visible, } = props;
  const isEN = getLocale() === 'en-US';
  // const { formatMessage } = useIntl();
  const formatMessage =
    props.formatMessage ||
    function (val) {
      return val.id
    }
  const [showModal, setShowModal] = useState(visible || false)
  const [disabled, setDisabled] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    tableSelectIndex: ['0'],
    timeScale: options.timeScale.default || _5MIN,
    sort: options?.sort?.default || 0,
  })

  useEffect(() => {
    setDisabled(formValue?.tableSelectIndex?.length === 0)
  }, [formValue?.tableSelectIndex])

  return (
    <Modal
      visible={showModal}
      size="auto"
      className={'download_options_modal'}
      caption={formatMessage({ id: 'realtime_info_download_settings' })}
      onClose={() => setShowModal(false)}
      onExited={() => onExited && onExited()}
      maskClosable
    >
      <Modal.Body>
        <Form>
          <Form.Item label={formatMessage({ id: 'realtime_info_download_metrics' })}>
            <CheckboxGroup className="download_options_modal_metrics"
              value={formValue?.tableSelectIndex}
              onChange={(val) => {
                if (val) {
                  setFormValue({ ...formValue, tableSelectIndex: val })
                }
              }}
            >
              <Checkbox name='0'>
                {options.table.firstName}
              </Checkbox>
              {
                formValue?.tableSelectIndex?.includes('0') &&
                <Radio.Group className="download_options_modal_metrics_time" value={formValue.timeScale} onChange={(val) => setFormValue({ ...formValue, timeScale: val })}>
                  <div className="download_options_modal_metrics_time_title">{formatMessage({ id: 'realtime_info_download_time' })}</div>
                  {options.timeScale.show[_60MIN] && (
                    <Radio name={_60MIN} disabled={options.timeScale.disabled[_60MIN]}>
                      {options?.downLoadCheckboxNameMap?.hour?.[isEN ? 'enName' : 'cnName'] || formatMessage({ id: 'realtime_info_download_by_hour' })}
                    </Radio>
                  )}
                  {options.timeScale.show[_10MIN] && (
                    <Radio name={_10MIN} disabled={options.timeScale.disabled[_10MIN]}>
                      {options?.downLoadCheckboxNameMap?.tenMin?.[isEN ? 'enName' : 'cnName'] || formatMessage({ id: 'realtime_info_download_by_10_min' })}
                    </Radio>
                  )}
                  {options.timeScale.show[_5MIN] && (
                    <Radio name={_5MIN} disabled={options.timeScale.disabled[_5MIN]}>
                      {options?.downLoadCheckboxNameMap?.fiveMinutes?.[isEN ? 'enName' : 'cnName'] || formatMessage({ id: 'realtime_info_download_by_5_min' })}
                    </Radio>
                  )}
                </Radio.Group>
              }
              <Checkbox name='1'>
                {options.table.secondName}
              </Checkbox>
            </CheckboxGroup>
          </Form.Item>
          <Form.Item label={formatMessage({ id: 'realtime_info_download_file_format' })}>
            <Form.Text>Excel</Form.Text>
          </Form.Item>
          {props.options.sort && (
            <Form.Item label={formatMessage({ id: 'realtime_info_download_sort' })}>
              <Radio.Group value={'' + formValue.sort} onChange={(val) => setFormValue({ ...formValue, sort: parseInt(val) })}>
                <Radio name={'1'}>{formatMessage({ id: 'realtime_info_download_sort_up' })}</Radio>
                <Radio name={'0'}>{formatMessage({ id: 'realtime_info_download_sort_down' })}</Radio>
              </Radio.Group>
            </Form.Item>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {
          disabled ?
            <Bubble
              arrowPointAtCenter
              placement="top"
              dark
              content={formatMessage({ id: 'common_select_content_download' })}
            >
              <Button
                disabled={disabled}
                type="primary"
                onClick={() => {
                  onConfirm && onConfirm(formValue)
                  setShowModal(false)
                }}
              >
                {formatMessage({ id: 'menu_confirm' })}
              </Button>
            </Bubble> :
            <Button
              disabled={disabled}
              type="primary"
              onClick={() => {
                onConfirm && onConfirm(formValue)
                setShowModal(false)
              }}
            >
              {formatMessage({ id: 'menu_confirm' })}
            </Button>
        }
        <Button type="weak" onClick={() => setShowModal(false)}>
          {formatMessage({ id: 'menu_cancel' })}{disabled}
        </Button>
      </Modal.Footer>
    </Modal >
  )
}
const showByApi = (props: DownloadOptions): Promise<void> => {
  return new Promise(function (resolve) {
    var el = document.createElement('div')
    ReactDom.render(
      createElement(DownloadOptionsModal, {
        ...props,
        visible: true,
        onConfirm: function (val) {
          props.onConfirm && props.onConfirm(val)
          return resolve(val)
        },
        onExited: function () {
          props.onExited && props.onExited()
          ReactDom.unmountComponentAtNode(el)
        },
      }),
      el,
    )
  })
}
export default DownloadOptionsModal
export { showByApi, DownloadOptions }
